import React from 'react';
import { trans, getImageFraction, currency, getVehicleTitle, getVehicleFullName } from 'js/utilities';

export default function ConversionFlowSummary({ summary, status }) {

    const { vehicle } = summary;


    return (
        <div className="flow-summary">
            {!vehicle && (
                <p className="summary-title">{trans('conversion_flow_bundle.flow.summary.title')}</p>
            )}

            {vehicle && (
                <>
                    <img
                        {...(vehicle?.image ?
                            getImageFraction({
                                path: vehicle.image,
                                ratio: 3 / 2,
                                fraction: 1,
                                breakpoints: {
                                    xl: {
                                        fraction: 3 / 12,
                                    },
                                },
                            }) :
                            {}
                        )}
                        alt={getVehicleFullName(vehicle?.brand, vehicle?.model, vehicle?.type)}
                        width="100%"
                        height="auto"
                        className="img-fluid mb-0 mb-lg-10"
                    />
                    <div className="d-flex flex-column">
                        <h5 className="text--16 text--lg-24 mb-0 mb-lg-2">{getVehicleTitle(vehicle?.brand, vehicle?.model)}</h5>
                        {vehicle?.type && (
                            <p className="mb-0 text--40 text-sm">{vehicle?.type}</p>
                        )}
                    </div>
                    {vehicle?.price && (
                        <div className="d-flex justify-content-between ms-auto mt-0 mt-lg-8">
                            <p className="d-none d-lg-flex text-sm">{trans('webstores_conversion_flow.buy')}</p>
                            <p className={`fw-bold text-sm mb-0${status === 'loading' ? ' flow__loading' : ''}`}>{currency(vehicle?.price)}</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
